import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryContactDeletionFailedAction = {
	type: 'BENEFICIARY_CONTACT_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryContactDeletionFailedAction => ({
	type: 'BENEFICIARY_CONTACT_DELETION_FAILED',
	payload,
});
